/**
 * Error Utilities
 *
 * Helper functions for consistent error handling across the application.
 */

/**
 * Convert unknown error to Error instance
 *
 * @param err - Unknown error from catch block
 * @returns Error instance
 */
export function toError(err: unknown): Error {
  return err instanceof Error ? err : new Error(String(err));
}

/**
 * Extract error message from unknown error
 *
 * @param err - Unknown error from catch block
 * @returns Error message string
 */
export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  }
  return String(err);
}
